<template>
  <router-link to="/home" aria-label="DMPeople" class="sidebar-logo">
    <span class="sidebar-logo__frame">
      <img
        src="/logo/dmpeople-horizontal-negativa.svg"
        alt=""
        class="sidebar-logo__horizontal"
        :class="{ 'is-hidden': collapse }"
      />
      <img
        src="/logo/dmpeople-simbolo-navy-pontolaranja.svg"
        alt=""
        class="sidebar-logo__symbol"
        :class="{ 'is-hidden': !collapse }"
      />
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  }
}
</script>
